"use client"

import BannerWithTracking from "@/components/BannerWithTracking"
import { toImageSrc } from "@/lib/utils"
import Image from "next/image"
import { Autoplay, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import "swiper/css"
import "swiper/css/pagination"
import "./bannerCarousel.css"

import type { BannerCarouselContentProps } from "@/types/types"
import { useBannerCarousel } from "../hooks/useBannerCarousel"

export const BannerCarouselContent = ({ id, banners = [], className = "" }: BannerCarouselContentProps) => {
  const { validBanners, hasValidBanners, swiperConfig } = useBannerCarousel({
    banners,
    componentId: id,
  })

  if (!hasValidBanners) {
    return null
  }

  return (
    <div className={`relative w-full h-[300px] sm:h-[690px] ${className}`} id={id}>
      <Swiper
        modules={[Pagination, Autoplay]}
        loop={swiperConfig.loop}
        autoplay={swiperConfig.autoplay}
        pagination={swiperConfig.pagination}
        className="banner-carousel-swiper w-full h-full"
      >
        {validBanners.map((banner, index) => {
          const imageUrl = toImageSrc(banner.image)

          return (
            <SwiperSlide key={index} className="w-full h-full">
              <BannerWithTracking
                bannerId={`${id}-${index}`}
                bannerUrl={banner.url}
                trackingConfig={banner.trackingConfig}
                className="relative w-full h-full"
              >
                <Image
                  src={imageUrl}
                  alt={`Banner ${index + 1}`}
                  fill
                  className="object-cover"
                  priority={index === 0}
                  unoptimized
                />
                <div className="absolute inset-0 bg-black/20 z-10" />
              </BannerWithTracking>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}
